import React, { useMemo } from 'react'

import { Table, TableRow } from '../../../../../components/pdf/Table'
import { TableColText, TableHeadText } from '../../../../../components/pdf/TableHelpers'
import Separator from '../../../../../components/pdf/Separator'
import Text from '../../../../../components/pdf/Text'
import View from '../../../../../components/pdf/View'
import { revisionDate, getValidity } from '../../_helpers/pdfHelpers'

const RevisionsSection = ({ serviceOrder }) => {
  const dateValidity = useMemo(() => {
    const validity = getValidity(serviceOrder)
    return validity
  }, [serviceOrder])
  return (
    <View pageBreakAfter>
      <Separator weight={15} />

      <Text bold size="small" align="center">
        CONTROLE DE REVISÕES
      </Text>

      <Separator weight={15} />

      <Table width="65%" center>
        <TableRow>
          <TableHeadText>Nº da Revisão</TableHeadText>
          <TableHeadText>Motivo</TableHeadText>
          <TableHeadText>Data da Alteração</TableHeadText>
        </TableRow>

        <TableRow>
          <TableColText>00</TableColText>
          <TableColText>Documento Base</TableColText>
          <TableColText>{revisionDate(dateValidity)}</TableColText>
        </TableRow>

        <TableRow>
          <TableColText></TableColText>
          <TableColText>Revisão Global</TableColText>
          <TableColText></TableColText>
        </TableRow>
      </Table>

      <Separator weight={150} />
    </View>
  )
}

export default RevisionsSection
